import * as React from 'react';
import * as vid from "./style.module.scss";
import data from "./data.json";
import { VideoReviews } from "../../../../VideoReviews";
export const VidReviews = () => {
  return (
    <section className={vid.vid}>
      <div className="container">
        <h2>Нас вдохновляют и поддерживают результаты и отзывы учеников</h2>
      </div>
      <VideoReviews data={data} buttonsColor={"#9C87D9"}/>
    </section>
  );
};
